import * as es from '../../../../../../config/locales/js/es.json';
angular.module('cerego.translate').constant('translateEs', es);
